var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',_vm._g({staticClass:"block w-full h-10 p-2 placeholder-gray-400 border border-gray-300 rounded appearance-none bg-color",class:{ 'bg-gray-50': _vm.$attrs.readonly || _vm.$attrs.readonly === 'readonly' },attrs:{"type":_vm.type},domProps:{"value":_vm.value}},_vm.listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }